import moment from "jalali-moment";

export const convertDate = (date) => {
  if (date) {
    const shamsi = moment(date)
      .format("jYYYY/jMM/jDD (HH:mm:ss)")
    return shamsi;
  } else {
    return "-";
  }
};